import { get } from 'lodash/fp';
import { createSelector } from 'reselect';
import { TimeUnit } from '@mews/enums';
import { CalendarEvent } from '@mews-commander/data-access';
import { getCurrentEnterpriseIanaTimeZoneIdentifier } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { isCurrentEnterpriseSpaceAllocationOptimizationEnabled } from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import { getSortedCalendarEvents } from '@mews-commander/legacy-entities/src/ducks/calendarEvents';
import parentSelector from '../selector';
import { MODULE_NAME } from './constants';
import { TimelineService } from './timelineService';
import { getSelectedTimeUnit } from './selectors/view';
import { CalendarEventExtended } from './types';

const moduleSelector = createSelector(parentSelector, (state) => state[MODULE_NAME]);

export default moduleSelector;
export const getTimeline = createSelector(moduleSelector, (state) => state[MODULE_NAME]);
export const getFilter = createSelector(getTimeline, get('filter'));
export const getTimelineFilterTimeUnit = createSelector(getFilter, get('timeUnit'));

export const getEvents = createSelector(
    getSortedCalendarEvents,
    getCurrentEnterpriseIanaTimeZoneIdentifier,
    getSelectedTimeUnit,
    (events: CalendarEvent[], timezone: string, timeUnit: TimeUnit): CalendarEventExtended[] =>
        (events || []).map((e) => {
            const { startUtc, endUtc } = e;
            const minX = Math.floor(TimelineService.utcToTimeUnitIndex(startUtc, timezone, timeUnit));
            const maxX = Math.ceil(TimelineService.utcToTimeUnitIndex(endUtc, timezone, timeUnit));

            return {
                ...e,
                minX,
                // if min and max are same we still want to display event in the timeline @see model.ts -> visibleEventsByDayIndex
                maxX: maxX === minX ? maxX + 1 : maxX,
                minY: 0,
                maxY: 0,
            };
        })
);

export const getTimelineResourceOptimizationEnabled = createSelector(
    isCurrentEnterpriseSpaceAllocationOptimizationEnabled,
    getSelectedTimeUnit,
    (isOptimizationEnabled: boolean, selectedTimeUnit) => isOptimizationEnabled && selectedTimeUnit !== TimeUnit.Month
);

export const getTimelineDraggingEnabled = createSelector(
    getSelectedTimeUnit,
    (timeUnit) => timeUnit !== TimeUnit.Month
);

export const getMonthViewReservationLengthRestrictionInfoMessageDisplayed = createSelector(
    getTimeline,
    get('isMonthViewReservationLengthRestrictionInfoMessageDisplayed')
);
